import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { handleSubmit, LoginError, loginErrorToI18nKey } from "../../api/login";
import { Button } from "../common/Button";
import { FormInput, FormLayout } from "../common/FormLayout";
import { PasswordField } from "../common/PasswordField";

export const LoginPage = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<LoginError | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const navigate = useNavigate();

  return (
    <FormLayout title={t("login-title")}>
      <div className="space-y-6">
        <form
          onSubmit={(e) =>
            handleSubmit(
              e,
              email,
              password,
              setError,
              setIsLoading,
              setIsConnected,
              isConnected,
              navigate
            )
          }
          className="space-y-6"
        >
          {error && (
            <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
              {t(loginErrorToI18nKey[error])}
            </div>
          )}

          <FormInput
            label={t("login-email")}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isLoading}
          />

          <PasswordField
            label={t("login-password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={isLoading}
          />

          <Button
            type="submit"
            size="full"
            disabled={!email || !password || isLoading}
            className={
              !email || !password || isLoading
                ? "opacity-50 cursor-not-allowed"
                : ""
            }
          >
            {t("login-submit")}
          </Button>
        </form>

        <div className="mt-6 text-center space-y-2">
          <a href="/register" className="block text-tertiary hover:underline">
            {t("login-createAccount")}
          </a>
          <Link
            to="/forgot-password"
            className="block text-tertiary hover:underline"
          >
            {t("login-forgotPassword")}
          </Link>
        </div>
      </div>
    </FormLayout>
  );
};
